import { useEffect, startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";
import { VideoPlayer } from "@shared/ui/VideoPlayer";
import captionsUrl from "@shared/assets/captions/Pollinator-HowItWorks-web.vtt";
import { MarketingSection } from "../MarketingSection/MarketingSection";
import { Invitation } from "@platform/types/platform.types";

export type MarketingHeroInvitationProps = {
  inviterName: string;
  onStart: (invitation: Invitation) => void;
};

export function MarketingHeroInvitation({
  inviterName,
  onStart,
}: MarketingHeroInvitationProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!inviterName || inviterName === "") return;

    startTransition(() => {
      navigate("/");
    });
  }, [inviterName]);

  return (
    <MarketingSection id="hero">
      <div className="flex flex-col gap-4 md:gap-6 border border-brand-800 px-4 py-8 rounded-lg md:px-8">
        <Type as="h1" variant="h1">
          <span className="text-brand-600">{inviterName}</span> invited you to
          join Pollinator.
        </Type>
        <Type as="p" variant="body1">
          Pollinator is a growing network of aligned peers. The inaugural
          Pollinator Program launches in October of 2025. Join a peer circle for
          five weeks of focused creative momentum.
        </Type>
        <Button
          className="w-full md:size-max"
          onClick={onStart}
          data-testid="marketing-hero-get-started"
        >
          Get Started
        </Button>
      </div>
      <VideoPlayer
        src="https://static.pollinator.coop/video/Pollinator-HowItWorks-web.mp4"
        poster="https://static.pollinator.coop/images/posters/vid-cap3.jpg"
        captionsUrl={captionsUrl}
        className="rounded-lg"
        controls={true}
        autoPlayOnMute={true}
        loop={true}
        title={`${inviterName} x Pollinator: Learn more`}
      />
    </MarketingSection>
  );
}

export default MarketingHeroInvitation;
